var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-box"},_vm._l((_vm.routeMap.children),function(route){return (_vm.showTag(route))?_c('li',{key:route.name,staticClass:"tag-item",attrs:{"data-sel":_vm.currentPath == route.path ? 'true' : 'false'},on:{"click":function($event){return _vm.handleTag(route)}}},[_vm._v(" "+_vm._s(_vm.getRouteTitle(route.name)))]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }